// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/advices.scss'

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html').animate({ scrollTop: $('#step-pagination').offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
    })
  })
}

// Newsletter Form
async function getNForm ($f) {
  $f.load()
  import(/* webpackChunkName: "newsletterForm" */ './js/components/newsletterForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des alertes BS
  const $c1 = $('.alert')
  if ($c1.length) {
    $c1.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des filtres de navigation
  const $c2 = $('.filter-nav')
  if ($c2.length) {
    $c2.waypoint(function () {
      import(/* webpackChunkName: "filterNav" */ './scss/components/filterNav.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $c3 = $('.pajinate')
  if ($c3.length) {
    $c3.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // css complémentaires à un article en détail
  const $c4 = $('.text-content')
  if ($c4.length) {
    $c4.waypoint(function () {
      import(/* webpackChunkName: "textContent", webpackPrefetch: true */ './scss/components/textContent.scss')
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire newsletter
  const $c5 = $('form[name="nForm"]')
  if ($c5.length) {
    $c5.waypoint(function () {
      getNForm($c5)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  if ($('.go').length) {
    const target = $('.go')
    $('html, body').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 20 }, function () {
      $('html, body').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 20 })
    })
  }
})
